'use client';

import { ReactNode } from 'react';
import { ScrollbarProps, Scrollbars } from 'react-custom-scrollbars-2';

interface CustomScrollBarProps extends ScrollbarProps {
  children: ReactNode;
  maxHeight: string;
}

const CustomScrollBar = ({
  children,
  maxHeight,
  ...rest
}: CustomScrollBarProps) => (
  <Scrollbars
    autoHide
    autoHideTimeout={1000}
    autoHideDuration={200}
    hideTracksWhenNotNeeded
    universal
    autoHeight
    autoHeightMax={maxHeight}
    {...rest}
  >
    {children}
  </Scrollbars>
);

export default CustomScrollBar;
